<template>
    <div>
        <h5 class="grey-color fw-600">Измените спецификацию</h5>
        <fl44-unknown-volume-supplementary-agreement-termination-specifications-edit-table v-model="form.deliverables" :v="$v.form.deliverables" :is-loading="isLoading" />
        <b-form-invalid-feedback :state="!$v.form.deliverables.$invalid" class="my-2" style="padding-left: 5px; padding-right: 5px" v-if="$v.form.deliverables.$invalid">{{ specErrorMessage }}</b-form-invalid-feedback>
        <text-row-price :label-cols-lg="4" label="Общая стоимость, руб." :value="specSum" />
        <text-row-price :label-cols-lg="4" label="Общая стоимость контракта, руб." :value="purchase.purchase_terms.contract_price" />
        <form-row-edit-date :label-cols-lg="4" label="Дата заключения дополнительного соглашения" v-model="form.conclusion_date" :v="$v.form.conclusion_date" :min-date="purchase.contract_date" :max-date="$now()" compact />
        <form-row-single-line-document-upload v-model="form.attachment" :label-cols-lg="4" :v="$v.form.attachment" title="Дополнительное соглашение" compact />
        <fl44-contract-supplementary-agreement-termination-limits-editable-table
            v-if="limitsRequired"
            v-model="form.limits"
            :total-cost="specSum"
            @validate="limitsValidate"
            :limit-year="purchase.purchase_terms.purchase_limit_year"
            :order-type="purchase.purchase_terms.order_type"
            purchase-type="fl44_unknown_volume"
            :purchase-id="purchase.id">
            <template #title>
                <h5 class="grey-color ml-1 mt-3 mb-1 main_text font-weight-bold">Измените лимиты</h5>
            </template>
            <template #label-hint> Добавьте или измените лимиты. Необходимо полностью распределить стоимость дополнительного соглашения по соответствующим лимитам. </template>
            <template #label-total> Стоимость дополнительного соглашения, руб.: </template>
            <template #label-variance> Отклонение от стоимости дополнительного соглашения, руб.: </template>
        </fl44-contract-supplementary-agreement-termination-limits-editable-table>
        <form-row-edit-supplier-accounting v-if="limitsRequired" v-model="form.supplier_accounting" @validate="supplierAccountingValidate">
            <template #title>
                <h5 class="ml-1 mt-3 mb-1 main_text font-weight-bold">Банковские реквизиты поставщика</h5>
            </template>
            <template #info>
                <div class="ml-1 fs-14">Укажите банковские реквизиты поставщика для заключения контракта, которые будут переданы в РИС после заключения.</div>
            </template>
        </form-row-edit-supplier-accounting>
        <b-overlay :show="isDataSending" rounded opacity="0.6" spinner-small spinner-variant="primary">
            <b-btn variant="custom-outline-secondary" class="text-uppercase mt-2" @click="onCancel">Отмена</b-btn>
            <b-btn :disabled="!$store.getters.getCanSign || $v.form.$invalid" @click="showSignForm" class="ml-2 mt-2" variant="custom-green">Подписать дополнительное соглашение</b-btn>
        </b-overlay>
        <template v-if="!$store.getters.getCanSign">
            <span v-if="$store.getters.getLoginType === 'cert'" class="text-danger pl-3 pt-0 fs-14 w-50 my-auto">Для действия требуется загрузить/заменить МЧД на странице: <router-link :to="{ name: 'CabinetUserProfile' }" class="green-link">Данные учетной записи</router-link></span>
            <span v-else class="text-danger pl-3 pt-0 fs-14 w-50 my-auto">Подписание возможно только при авторизации при помощи ЭЦП</span>
        </template>
        <p class="font-weight-bold text-danger mt-3 mb-1 fs-14">Внимание! Для данной закупки будут заблокированы функции: изменение лимитов, добавление дополнительного соглашения, изменение статуса.</p>
        <b-modal ref="sign-form-modal" v-model="showSignModal" centered no-close-on-backdrop no-close-on-esc scrollable size="lg" title="Подписать дополнительное соглашение" @close="cancelSignModal">
            <template #modal-header-close>
                <button-close-modal />
            </template>
            <div class="d-block text-left">
                <b-tabs content-class="mt-3 px-3">
                    <b-tab active>
                        <template #title>
                            <span class="system_link-style fs-16">Информация о документе</span>
                        </template>
                        <h4 class="font-weight-bold">Информация о заказчике</h4>
                        <text-row compact label="Наименование организации" :value="purchase.contract.customer.name" />
                        <text-row compact label="ИНН" :value="purchase.contract.customer.inn" />
                        <text-row compact label="КПП" :value="purchase.contract.customer.kpp" />
                        <text-row compact label="ОГРН" :value="purchase.contract.customer.ogrn" />
                        <text-row compact label="Адрес" :value="purchase.contract.customer.legal_address" />

                        <h4 class="font-weight-bold">Информация о поставщиике</h4>
                        <text-row compact label="Наименование организации" :value="purchase.contract.supplier.name" />
                        <text-row compact label="ИНН" :value="purchase.contract.supplier.inn" />
                        <text-row compact label="КПП" :value="purchase.contract.supplier.kpp" />
                        <text-row compact label="ОГРН" :value="purchase.contract.supplier.ogrn" />
                        <text-row compact label="Адрес" :value="purchase.contract.supplier.legal_address" />

                        <hr />
                        <h4 class="font-weight-bold">Дополнительное соглашение о расторжении контракта</h4>
                        <text-row-date compact :label-cols-lg="4" :label-cols-sm="4" label="Дата заключения дополнительного соглашения" :value="form.conclusion_date" />
                        <text-row-price compact :label-cols-lg="4" :label-cols-sm="4" label="Общая стоимость, руб." :value="specSum" />
                        <text-row-single-document compact :label-cols-lg="4" :label-cols-sm="4" label="Документы" :value="form.attachment" />

                        <hr />
                        <h4 class="font-weight-bold">Спецификация</h4>
                        <b-form-group v-if="form.deliverables.length > 0">
                            <ul>
                                <li v-for="(item, index) in form.deliverables" :key="index" class="fs-14 grey-color my-auto col-form-label">
                                    {{ index + 1 + '.' }} {{ item.ktru_item.name }} - {{ item.amount }} {{ item.ktru_item.okei_local_symbol }} * {{ $formatPrice(item.price) }} руб. = {{ $formatPrice(item.amount * item.price) }} руб.
                                </li>
                            </ul>
                        </b-form-group>
                    </b-tab>
                    <b-tab>
                        <template #title>
                            <span class="system_link-style fs-16">XML</span>
                        </template>
                        <b-form-textarea v-if="!isSignedXml" v-model="formXml" disabled rows="20" no-resize no-auto-shrink wrap="off" class="text-monospace fs-12"></b-form-textarea>
                        <b-form-textarea v-else v-model="signedFormXml" disabled rows="20" no-resize no-auto-shrink wrap="off" class="text-monospace fs-12"></b-form-textarea>
                    </b-tab>
                </b-tabs>
            </div>
            <div slot="modal-footer" class="w-100 px-3">
                <text-row compact label="Сертификат" :value="certificate?.subjectName" />
                <b-button :disabled="isDataSending" class="mr-2 text-uppercase" variant="custom-outline-secondary" @click="cancelSignModal">Отмена</b-button>
                <b-overlay v-if="!isSignedXml" :show="isSigningXml" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button :disabled="!certificate" class="text-uppercase" variant="custom-green" @click="signForm">Подписать</b-button>
                </b-overlay>
                <b-overlay v-else :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button :disabled="!certificate" class="text-uppercase" variant="custom-green" @click="sendData">Отправить</b-button>
                </b-overlay>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { minValue, required, requiredIf } from 'vuelidate/lib/validators';
import roundToTwoDecimals from '@lib/js/src/misc/roundToTwoDecimals';
import FormRowEditSupplierAccounting from '@/components/common/form-rows/form-row-edit-supplier-accounting.vue';
import Config from '@core/js/ddriven/application/config/Config';
import { createMultipleSignatures, getCertificate } from 'crypto-pro';
import Fl44ContractSupplementaryAgreementTerminationLimitsEditableTable from '@/components/products/fl44/partials/fl44-contract-supplementary-agreement-termination-limits-editable-table.vue';
import Fl44UnknownVolumeSupplementaryAgreementTerminationSpecificationsEditTable from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-supplementary-agreement-termination-specifications-edit-table.vue';

export default {
    name: 'fl44-unknown-volume-create-supplementary-agreement-termination-other-block',
    components: {
        Fl44UnknownVolumeSupplementaryAgreementTerminationSpecificationsEditTable,
        Fl44ContractSupplementaryAgreementTerminationLimitsEditableTable,
        FormRowEditSupplierAccounting
    },
    props: {
        purchase: {
            type: Object
        },
        terminationType: {
            type: String
        }
    },
    data() {
        return {
            isLoading: false,
            price: null,
            priceLimit: null,
            form: {
                conclusion_date: null,
                attachment: null,
                type: 'termination',
                deliverables: [],
                limits: [],
                supplier_accounting: {
                    bank_type: 'bank',
                    bik: null,
                    bank_name: null,
                    bank_city: null,
                    ks: null,
                    rs: null,
                    ls: null,
                    fo_inn: null,
                    fo_name: null
                }
            },
            isLimitsValid: false,
            isSupplierAccountingValid: false,
            showSignModal: false,
            isSigningXml: false,
            formXml: '',
            signedAttachments: [],
            signedFormXml: null,
            isSignedXml: false,
            isDataSending: false,
            certificate: null
        };
    },
    validations() {
        return {
            form: {
                conclusion_date: {
                    required
                },
                attachment: {
                    required
                },
                deliverables: {
                    required,
                    priceLimit() {
                        return this.specSum <= this.priceLimit;
                    },
                    $each: {
                        ktru_item: {
                            id: { required }
                        },
                        amount: { required, minValue: minValue(0) },
                        minAmount(item) {
                            return item.amount >= item.min_amount;
                        }
                    }
                },
                limits: {
                    isLimitsValid() {
                        return !this.limitsRequired || this.isLimitsValid;
                    }
                },
                supplier_accounting: {
                    required: requiredIf(() => this.limitsRequired),
                    isSupplierAccountingValid() {
                        return !this.limitsRequired || this.isSupplierAccountingValid;
                    }
                }
            }
        };
    },
    mounted() {
        this.fillData();
    },
    methods: {
        onCancel() {
            this.$emit('cancel');
        },
        async fillData() {
            this.isLoading = true;
            await this.$api.products.fl44UnknownVolume.supplementaryAgreements
                .getSupplementaryAgreementTerminationTemplateData(this.purchase.id, this.purchase.contract.id)
                .then((response) => {
                    this.form.deliverables = response.deliverables;
                    this.contract_conclusion_date = response.contract_conclusion_date;
                    this.price = response.price;
                    this.priceLimit = response.price;
                    this.form.supplier_accounting = response.supplier_accounting;
                    this.form.limits = response.limits;
                })
                .catch(() => {
                    this.$emit('cancel');
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        async createSupplementaryAgreement() {
            this.isLoading = true;
            await this.$api.personal.fl44
                .sendSupplementaryAgreementToSupplier(this.purchase.id, this.form)
                .then(() => {
                    this.$emit('done');
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        limitsValidate(value) {
            this.isLimitsValid = !value;
        },
        supplierAccountingValidate(value) {
            this.isSupplierAccountingValid = !value;
        },
        async signForm() {
            this.isSigningXml = true;
            const dataToSign = [
                { method: 'xml', value: this.formXml },
                { method: 'detached', value: this.form.attachment.hash, id: this.form.attachment.id }
            ];
            const attachmentsCount = dataToSign.filter((item) => item.method === 'detached').length;
            const signedResult = await createMultipleSignatures(this.$store.getters.getCurrentThumbprint, dataToSign, true);
            this.signedFormXml = signedResult.find((item) => item.method === 'xml').result;
            this.signedAttachments.splice(0);
            if (attachmentsCount > 0) {
                dataToSign
                    .filter((item) => item.method === 'detached')
                    .forEach((item) => {
                        const result = signedResult.find((resultItem) => resultItem.method === 'detached' && resultItem.value === item.value);
                        this.signedAttachments.push({
                            id: item.id,
                            hash: item.value,
                            md5: result.result
                        });
                    });
            }

            this.isSignedXml = !!this.signedFormXml && this.signedAttachments.length === attachmentsCount && this.signedAttachments.every((item) => item.md5 !== null);
            this.isSigningXml = false;
        },
        prepareXMLFormData() {
            const deliverables = this.form.deliverables.map((deliverable) => {
                return {
                    purchase_deliverable_id: deliverable.id,
                    ktru_item_id: deliverable.ktru_item_id,
                    amount: deliverable.amount,
                    price: deliverable.price
                };
            });
            return {
                termination_type: this.terminationType,
                conclusion_date: this.form.conclusion_date,
                attachment: {
                    id: this.form.attachment.id,
                    name: this.form.attachment.name
                },
                deliverables: deliverables,
                total_cost: this.specSum
            };
        },
        async sendData() {
            // this.isDataSending = true;
            this.certificate = await getCertificate(this.$store.getters.getCurrentThumbprint);
            if (!this.certificate) {
                return;
            }
            const data = {
                ...this.prepareXMLFormData(),
                xml: this.signedFormXml,
                certificate: this.certificate,
                signed_attachments: this.signedAttachments,
                limits: this.form.limits,
                supplier_accounting: this.form.supplier_accounting
            };

            await this.$api.products.fl44UnknownVolume.supplementaryAgreements
                .storeCustomerSignedSupplementaryAgreementTermination(this.purchase.id, this.purchase.contract.id, data)
                .then((response) => {
                    if (response) {
                        this.cancelSignModal();
                        this.$emit('done');
                    }
                })
                .finally(() => {
                    this.isDataSending = false;
                });
        },
        async showSignForm() {
            if (!this.$store.getters.getCanSign) {
                return;
            }
            this.certificate = await getCertificate(this.$store.getters.getCurrentThumbprint);
            if (!this.certificate) {
                return;
            }
            await this.$api.products.fl44UnknownVolume.supplementaryAgreements.getTerminationSupplementaryAgreementXML(this.purchase.id, this.purchase.contract.id, this.prepareXMLFormData()).then((resp) => {
                this.formXml = resp.xml;
                this.showSignModal = true;
            });
        },
        cancelSignModal() {
            this.isSignedXml = false;
            this.showSignModal = false;
            this.isSigningXml = false;
        }
    },
    computed: {
        Config() {
            return Config;
        },
        features() {
            return Config.get('theme.features');
        },
        specSum() {
            return roundToTwoDecimals(
                this.form.deliverables.reduce((sum, item) => {
                    return (sum += roundToTwoDecimals(item.amount * item.price));
                }, 0)
            );
        },
        specErrorMessage() {
            const deliverables = Object.values(this.$v.form.deliverables.$each.$iter);
            if (deliverables.some((e) => e.amount.$invalid)) return 'У одной или более позиций в таблице спецификации не заполнено поле "Количество фактическое"';
            if (!this.$v.form.deliverables.priceLimit) return `Сумма по ДС о расторжении не должна превышать сумму контракта / ДС (${this.$formatPrice(this.priceLimit)} руб.)`;
            return '';
        },
        limitsRequired() {
            return this.features.kbk_limits && !this.purchase.purchase_terms.without_limits && this.form.termination_type !== 'agreement_of_parties';
        }
    }
};
</script>
